import { sanitizeNames } from "../utils/format";

export default{


    setToken(state, token){
        state.token = token;
    },

    setAssignments(state, assignments){
        state.assignments = assignments;
    },

    setBatches(state, batches){
        state.batches = batches;
    },

    setCourses(state, courses){
        state.courses = courses;
    },


    setDepartments(state, departments){
     state.departments = departments;
    },

    setEvents(state, events){
        state.events = events;
    },

    setGroups(state, groups){
        state.groups = groups;
    },

    setFaculties(state, faculties){
        state.faculties = faculties;
    },

    setStudents(state, students){
        state.students = students;
    },

    setStaffs(state, staffs){
        state.staffs = staffs;
    },

    setTeachers(state, teachers){
        state.teachers = teachers;
    },
    setPrograms(state, programs){
        state.programs = programs;
    },
    setProfile(state, profile){
        sanitizeNames(profile);
        state.profile = profile;
    },
    setKycData(state, kycdata){
        state.kycdata = kycdata;
    },
    setKycRequestMessage(state, kycrequestmessage){
        state.kycrequestmessage = kycrequestmessage;
    },
    setRegisterErrors(state, registerErrors){
        state.registerErrors = registerErrors;
    },
    setRegisterEmail(state, registerEmail){
        state.registerEmail = registerEmail;
    },
    setOtpExpiresIn(state, otpExpiresIn){
        state.otpExpiresIn = otpExpiresIn;
    },
    setRegisterStatus(state, registerStatus){
        state.registerStatus = registerStatus;
    },
    setRecentProfile(state, recentProfile){
        sanitizeNames(recentProfile);
        state.recentProfile = recentProfile;
    },
    setTransactions(state, transactions){
        sanitizeNames(transactions);
        state.transactions = transactions;
    },
    setPayment(state, payment){
        state.payment = payment;
    },

    setLoadFund(state, loadfund){
        state.loadfund = loadfund;
    },

    setBanks(state, banks){
        state.banks = banks;
    },

    setNotifications(state, notifications){
        sanitizeNames(notifications);
        state.notifications = notifications;
    },

    setstaticPage(state, staticpage){
        state.staticpage = staticpage;
    },

    setRequests(state, requests){
        state.requests = requests;
    },

    setMessage(state, message){
        state.message = message;
    },

    setPhonenumber(state, phonenumber){
        state.phonenumber = phonenumber;
    },

    setTransactionid(state, transaction_id){
        state.transaction_id = transaction_id;
    },

    setRequestid(state, requestid){
        state.requestid = requestid;
    },

    setSuccessMessage(state, successmessage){
        state.successmessage = successmessage;
    },
    setStep(state, stepincrease){
        state.step = stepincrease;
    },

    setPasswordRestMessage(state, passwordmessage){
        state.passwordmessage = passwordmessage;
    },

    setOtpsuccess(state, otpsuccess){
        state.otpsuccess = otpsuccess;
    },

    setOtperror(state , otperror){
        state.otperror = otperror;
    },

    setRequestMessage(state , requestmessage){
        state.requestmessage = requestmessage;
    },

    setOtpMessage(state, otpmessage){
        state.otpmessage = otpmessage;
    },

    setErrorMessage(state, errormessage){
        state.errormessage = errormessage;
    },

    setActionUrl(state, actionurl){
        state.actionurl = actionurl;
    },

    setAddbankSuccessMessage(state, addbanksuccess){
        state.addbanksuccess = addbanksuccess;
    },

    setWithdrawid(state, withdraw_id){
        state.withdraw_id = withdraw_id;
    },

    setOTPSuccessMessage(state, setotpSuccessMessage){
        state.setotpSuccessMessage = setotpSuccessMessage;
    },

    setAmount(state,useramount){
        state.useramount = useramount;
    },

    setMerchant(state, merchant){
        sanitizeNames(merchant);
        state.merchant = merchant;
    },
    setAccountSuccessMessage(state, accountsuccessmessage){
        state.accountsuccessmessage = accountsuccessmessage;
    },
    setDownloadMessage(state, downloadsuccess){
        state.downloadsuccess = downloadsuccess;
    },

    setCardLoadErrorMessage(state, cardloaderrormessage){
      state.cardloaderrormessage = cardloaderrormessage;
    },

    setAllBank(state, allbanks){
      state.allbanks = allbanks;
    },

    setfundResponse(state, fundResponse){
      state.fundResponse = fundResponse;
    },

    setCountries(state, countries){
        state.countries = countries;
    },

    setSQuestions(state, sQuestions){
        state.sQuestions = sQuestions;
    },

    setSQuestionAnswers(state, sQuestionAnswers){
        state.sQuestionAnswers = sQuestionAnswers;
    },

    setDocumentTypes(state, documentTypes){
        state.documentTypes = documentTypes;
    },

    setUserDocuments(state, userDocuments){
        state.userDocuments = userDocuments;
    },

    setTimezones(state, timezones){
        state.timezones = timezones;
    },

    setCurrencies(state, currencies){
        state.currencies = currencies;
    },

    setAdminBanks(state, adminBanks){
        state.adminBanks = adminBanks;
    },

    setUserBanks(state, userBanks){
        sanitizeNames(userBanks);
        state.userBanks = userBanks;
    },

    setPayuHash(state, payuHash){
        state.payuHash = payuHash;
    },
    
    setMerchants(state, merchants){
        sanitizeNames(merchants);
        state.merchants = merchants;
    },

    setMerchantDocument(state, merchant_documents){
        state.merchant_documents = merchant_documents;
    },
    
    setMerchantPaymentDetail(state, merchant_payment_details){
        sanitizeNames(merchant_payment_details);
        state.merchant_payment_details = merchant_payment_details;
    },

    setMerchantWithdraw(state, merchant_withdraw){
        state.merchant_withdraw = merchant_withdraw;
    },
    
    setMerchantKey(state, merchant_key){
        state.merchant_key = merchant_key;
    },
    
    setMerchantDashboardCount(state, merchant_dashboard_count){
        state.merchant_dashboard_count = merchant_dashboard_count;
    },
    
    setMerchantDashboardTransaction(state, merchant_dashboard_transaction){
        state.merchant_dashboard_transaction = merchant_dashboard_transaction;
    },
    
    setMerchantEnvironment(state, environment){
        const value = (environment === 'sandbox') ? 'sandbox' : 'live';
        state.merchantEnvironment = value;
        try { window.localStorage.setItem('merchantEnvironment', value); } catch (e) { /* ignore */ }
    },
    setMerchantDashboard(state, merchantDashboard){
        sanitizeNames(merchantDashboard);
        state.merchantDashboard = merchantDashboard;
    },
    setMerchantAnalytics(state, merchantAnalytics){
        state.merchantAnalytics = merchantAnalytics;
    },
    setMerchantCustomers(state, merchantCustomers){
        sanitizeNames(merchantCustomers);
        state.merchantCustomers = merchantCustomers;
    },
    setPaymentIntent(state, paymentIntent){
        state.paymentIntent = paymentIntent;
    },
    setMpinStatus(state, mpinStatus){
        state.mpinStatus = mpinStatus;
    },
    setUserKyc(state, userKyc){
        state.userKyc = userKyc;
    },
    setUserBankDetail(state, userBankDetail){
        sanitizeNames(userBankDetail);
        state.userBankDetail = userBankDetail;
    },
    setUserWithdraws(state, userWithdraws){
        sanitizeNames(userWithdraws);
        state.userWithdraws = userWithdraws;
    },
    setPaymentRequests(state, paymentRequests){
        sanitizeNames(paymentRequests);
        state.paymentRequests = paymentRequests;
    },
    setUserPayments(state, userPayments){
        sanitizeNames(userPayments);
        state.userPayments = userPayments;
    },
    setRecipient(state, recipient){
        sanitizeNames(recipient);
        state.recipient = recipient;
    },
    setMerchantWithdraws(state, merchantWithdraws){
        state.merchantWithdraws = merchantWithdraws;
    },
    setMerchantWithdrawAnalytics(state, merchantWithdrawAnalytics){
        state.merchantWithdrawAnalytics = merchantWithdrawAnalytics;
    },
    setMerchantPayments(state, merchantPayments){
        sanitizeNames(merchantPayments);
        state.merchantPayments = merchantPayments;
    },
    setCurrencyCountries(state, currencyCountries){
        state.currencyCountries = currencyCountries;
    },
    setUserStatement(state, userStatement){
        // counterparty names arrive as "Sushil  Subedi" / "admin  user"
        sanitizeNames(userStatement);
        state.userStatement = userStatement;
    },
    setUserStatementDetail(state, userStatementDetail){
        sanitizeNames(userStatementDetail);
        state.userStatementDetail = userStatementDetail;
    },
    setMerchantStatement(state, merchantStatement){
        // counterparty names arrive with doubled spaces ("Sushil  Subedi")
        sanitizeNames(merchantStatement);
        state.merchantStatement = merchantStatement;
    },
    setMerchantPaymentDetail(state, merchantPaymentDetail){
        state.merchantPaymentDetail = merchantPaymentDetail;
    },
    setMerchantDashboardCashFlow(state, merchant_dashboard_cashflow){
        state.merchant_dashboard_cashflow = merchant_dashboard_cashflow;
    },

}
